import { render } from "./CreateCompetitionBonusModalForm.vue?vue&type=template&id=46908574"
import script from "./CreateCompetitionBonusModalForm.vue?vue&type=script&lang=js"
export * from "./CreateCompetitionBonusModalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__